(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lbrgt-top-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('change', function (e) {
      var input = e.target.closest('.custom-top-filters input[type="checkbox"]');
      if (!input) return;

      var facetFiltersEl = document.getElementById('facet-filters');
      var form = document.getElementById('facets');
      if (!facetFiltersEl || !form) return;

      var matchingSidebarInput = form.querySelector(
        'input[name="' + CSS.escape(input.name) + '"][value="' + CSS.escape(input.value) + '"]'
      );
      if (matchingSidebarInput && matchingSidebarInput !== input) {
        matchingSidebarInput.checked = input.checked;
      }

      if (typeof facetFiltersEl.applyFilters === 'function') {
        var formData = new FormData(form);
        var searchParams = new URLSearchParams(formData);
        var emptyParams = [];

        searchParams.forEach(function (value, key) {
          if (!value) emptyParams.push(key);
        });
        emptyParams.forEach(function (key) {
          searchParams.delete(key);
        });

        facetFiltersEl.applyFilters(searchParams.toString(), null);
      }
    });

    document.addEventListener('click', function (e) {
      var dropdown = e.target.closest('.top-filter-dropdown');

      // Reset: uncheck this group's inputs, then trigger the
      // facet-filters component's own update method directly
      var resetBtn = e.target.closest('[data-filter-reset]');
      if (resetBtn && dropdown) {
        e.preventDefault();

        var facetFiltersEl = document.getElementById('facet-filters');
        var form = document.getElementById('facets');

        dropdown.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
          input.checked = false;

          if (form) {
            var matchingSidebarInput = form.querySelector(
              'input[name="' + CSS.escape(input.name) + '"][value="' + CSS.escape(input.value) + '"]'
            );
            if (matchingSidebarInput && matchingSidebarInput !== input) {
              matchingSidebarInput.checked = false;
            }
          }
        });

        if (facetFiltersEl && form && typeof facetFiltersEl.applyFilters === 'function') {
          var formData = new FormData(form);
          var searchParams = new URLSearchParams(formData);
          var emptyParams = [];

          searchParams.forEach(function (value, key) {
            if (!value) emptyParams.push(key);
          });
          emptyParams.forEach(function (key) {
            searchParams.delete(key);
          });

          facetFiltersEl.applyFilters(searchParams.toString(), null);
        }

        return;
      }
      // Apply: just close the dropdown (filtering already applied live)
      var applyBtn = e.target.closest('[data-filter-apply]');
      if (applyBtn && dropdown) {
        dropdown.removeAttribute('open');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
